import { render, staticRenderFns } from "./ClientEdit.vue?vue&type=template&id=83c0ef96&scoped=true"
import script from "./ClientEdit.vue?vue&type=script&lang=js"
export * from "./ClientEdit.vue?vue&type=script&lang=js"
import style0 from "./ClientEdit.vue?vue&type=style&index=0&id=83c0ef96&prod&lang=css"
import style1 from "./ClientEdit.vue?vue&type=style&index=1&id=83c0ef96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c0ef96",
  null
  
)

export default component.exports